import { useBulletinListQuery } from "entities/bulletin/queries/useBulletinListQuery";
import { Bulletin } from "entities/bulletin/types";
import { FC, PropsWithChildren, useState } from "react";
import { useDrawerState } from "shared/hooks/useDrawerState";
import useToggle from "shared/hooks/useToggle";
import { createContext } from "shared/utils/context";
import { BulletinBoardPageType } from "./types";

const [Provider, useBulletinBoardPage] = createContext<BulletinBoardPageType>({
  name: "BulletinBoardPageContext",
  hookName: "useBulletinBoardPage",
  providerName: "BulletinBoardPageProvider",
});

const BulletinBoardPageProvider: FC<PropsWithChildren> = (props) => {
  const bulletinBoardDetailsDrawer = useDrawerState<string>();

  const [openDeleteModal, setOpenDeleteModal] = useToggle(false);
  const [selectedBulletin, setSelectedBulletin] = useState<Bulletin | null>(
    null,
  );
  const { data = [], isLoading } = useBulletinListQuery();

  const handleDeleteModal = () => {
    setOpenDeleteModal();

    if (openDeleteModal) {
      setSelectedBulletin(null);
    }
  };

  const value: BulletinBoardPageType = {
    data,
    isLoading: isLoading,
    bulletinBoardDetailsDrawer,
    selectedBulletin,
    setSelectedBulletin,
    openDeleteModal,
    handleDeleteModal,
  };

  return <Provider value={value}>{props.children}</Provider>;
};

export { BulletinBoardPageProvider, useBulletinBoardPage };
